import React, { useContext, useRef, useState, useEffect } from "react";
import logo from "../../static/VHU1.png";
import { FiMenu, FiLogOut, FiUser } from "react-icons/fi";
import { getMail } from "../../utils/services";
import { useMsal } from "@azure/msal-react";
import { Link, useNavigate } from "react-router-dom";
import { GlobalState } from "../../GlobalState";

const CSS_design = {
  li: "px-4 py-2 cursor-pointer hover:text-blue-600 transition-colors duration-200 relative font-medium",
};

export default function Header() {
  const state = useContext(GlobalState);
  const [isAdmin, setIsAdmin] = state.isAdmin;
  const [admin, setAdmin] = state.admin;
  const [openTask, setOpenTask] = useState(null);

  const [showMenu, setShowMenu] = useState(false);
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();
  const headerRef = useRef(null);
  const { instance } = useMsal();
  const mail = getMail();

  useEffect(() => {
    const updateUserName = () => {
      try {
        const raw =
          sessionStorage.getItem("userInfo") ||
          sessionStorage.getItem("userinfo") ||
          sessionStorage.userInfo ||
          sessionStorage.userinfo;
        if (raw) {
          const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
          const name = parsed?.userEvent?.name || parsed?.name || "";
          setUserName(name);
        }
      } catch (e) {
        console.error("Error parsing userInfo from sessionStorage:", e);
      }
    };

    updateUserName();
    const interval = setInterval(updateUserName, 1000);
    return () => clearInterval(interval);
  }, []);

  const LogOut = async () => {
    sessionStorage.clear();
    localStorage.clear();
    if (mail) {
      instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin,
      });
    } else {
      window.location.reload();
    }
  };

  // Scroll to section by id
  const scrollToSection = (id) => {
    setShowMenu(false);
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 200); // Wait for menu to close
  };

  // Mobile menu items for scroll
  const mobileSections = [
    // { id: "section-doithi", label: "Danh sách đội" },
    { id: "section-nhiemvu", label: "Hướng dẫn thi ảnh" },
    { id: "section-xephang", label: "Bảng xếp hạng" },
    { id: "section-giaithuong", label: "Giải thưởng" },
  ];

  const TaskPopup = ({ task, onClose }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-[#0091EB]/90 rounded-2xl shadow-xl max-w-2xl max-md:max-w-full max-md:mx-4 w-full py-4 relative animate-fadeIn">
        <div className="transform -translate-y-8 scale-[1.02] border w-full bg-gradient-to-b from-[#07B4FE] to-[#0044D7] rounded-3xl relative z-10 flex items-center justify-center leading-tight h-fit p-4">
          <button
            className="absolute top-2 right-4 text-2xl text-white hover:text-red-500"
            onClick={onClose}
          >
            &times;
          </button>
          <h2 className="bg-gradient-to-b leading-normal text-5xl max-lg:text-2xl text-center from-[#FFD942] via-[#FFA22F] to-[#FF7E22] bg-clip-text text-transparent font-bold">
            LIÊN HỆ HỖ TRỢ
          </h2>
        </div>
        <div className="text-white text-xl px-6">
          <h3>TRUNG TÂM TRUYỀN THÔNG</h3>
          <span>
            Ông Hoàng Xuân Ái - Phó Giám đốc <br /> Email: aihx@hunghau.vn{" "}
            <br /> Phone: 0967500333
          </span>
          <h3 className="mt-4">KHỐI CÔNG NGHỆ</h3>
          <span>
            Ông Phạm Văn Thi - Trưởng phòng <br /> Email: thipv@hexagon.xyz{" "}
            <br />
            Phone: +84979800280
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <header className="w-full bg-white shadow-md relative z-30">
      <div
        ref={headerRef}
        className="w-full max-w-[1400px] mx-auto md:flex md:items-center md:justify-between justify-between p-[15px] min-h-[90px] px-[20px]"
      >
        {openTask && (
          <TaskPopup task={openTask} onClose={() => setOpenTask(null)} />
        )}
        {/* Logo & Menu Icon */}
        <div className="flex basis-[30%] max-md:justify-between md:justify-start md:w-[20%] items-center">
          <Link
            to="/"
            className="transform hover:scale-105 transition-transform duration-200"
          >
            <img
              src={logo}
              alt="Logo"
              className="w-[300px] object-cover mr-[15px] cursor-pointer hover:opacity-90 transition-opacity"
            />
          </Link>
          <div className="flex items-center gap-2 md:hidden">
            {userName && (
              <div className="flex items-center gap-1.5 px-2.5 py-1 bg-blue-50 border border-blue-200 rounded-full text-blue-800 text-xs font-semibold max-w-[140px]">
                <FiUser className="text-blue-600 flex-shrink-0" />
                <span className="truncate" title={userName}>
                  {userName}
                </span>
              </div>
            )}
            <FiMenu
              size={"30px"}
              className="cursor-pointer text-gray-800 hover:text-blue-600 transition-colors duration-200 transform hover:scale-110"
              onClick={() => setShowMenu(!showMenu)}
            />
          </div>
        </div>

        {/* Desktop Menu */}
        <div className="flex gap-8 max-md:hidden text-base text-gray-800 items-center basis-[70%] justify-center font-semibold">
          <li
            className="text-gray-800 hover:text-[#0043D3] list-none relative cursor-pointer group py-2"
            onClick={() => scrollToSection("section-nhiemvu")}
          >
            <span className="relative z-10 font-bold">Hướng dẫn thi ảnh</span>
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#0043D3] group-hover:w-full transition-all duration-300"></span>
          </li>
          <li
            className="text-gray-800 hover:text-[#0043D3] list-none relative cursor-pointer group py-2"
            onClick={() => scrollToSection("section-xephang")}
          >
            <span className="relative z-10 font-bold">Bảng xếp hạng</span>
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#0043D3] group-hover:w-full transition-all duration-300"></span>
          </li>
          <li
            className="text-gray-800 hover:text-[#0043D3] list-none relative cursor-pointer group py-2"
            onClick={() => scrollToSection("section-giaithuong")}
          >
            <span className="relative z-10 font-bold">Giải thưởng</span>
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#0043D3] group-hover:w-full transition-all duration-300"></span>
          </li>
        </div>

        {/* Desktop Right Menu */}
        <ul
          className={`${
            showMenu
              ? "opacity-100 transform translate-y-0"
              : "opacity-0 md:opacity-100 transform -translate-y-2 md:translate-y-0 hidden md:flex"
          } md:flex max-md:hidden justify-end transition-all duration-300 ease-in-out basis-[30%] items-center`}
        >
          {userName && (
            <li className="flex items-center gap-2 px-3.5 py-1.5 bg-blue-50 border border-blue-200 rounded-full text-blue-800 text-sm font-semibold shadow-sm">
              <FiUser className="text-blue-600 text-base flex-shrink-0" />
              <span className="truncate max-w-[160px] lg:max-w-[220px]" title={userName}>
                {userName}
              </span>
            </li>
          )}
          <li
            onClick={LogOut}
            className={`${CSS_design.li} group flex items-center gap-2 ml-4 bg-red-50 hover:bg-red-100 rounded-full px-6 py-2 text-red-600 hover:text-red-700 transition-all duration-300 transform hover:scale-105`}
          >
            <FiLogOut className="text-lg group-hover:rotate-90 transition-transform duration-300" />
            <span>Đăng xuất</span>
          </li>
        </ul>

        {/* Mobile Drawer Menu */}
        {showMenu && (
          <div
            className="fixed inset-0 bg-black bg-opacity-40 z-50 md:hidden"
            onClick={() => setShowMenu(false)}
          >
            <div
              className="absolute top-0 right-0 w-3/4 max-w-xs h-full bg-white shadow-lg flex flex-col p-6 gap-4"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="self-end mb-4 text-gray-600 text-2xl"
                onClick={() => setShowMenu(false)}
              >
                &times;
              </button>
              {userName && (
                <div className="flex items-center gap-2 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg text-blue-800 text-sm font-semibold mb-2">
                  <FiUser className="text-blue-600 text-lg flex-shrink-0" />
                  <span className="truncate" title={userName}>
                    {userName}
                  </span>
                </div>
              )}
              {mobileSections.map((section) => (
                <div
                  key={section.id}
                  className="py-2 border-b text-[#0253e1] font-semibold cursor-pointer"
                  onClick={() => scrollToSection(section.id)}
                >
                  {section.label}
                </div>
              ))}
              <button
                onClick={() => {
                  setShowMenu(false);
                  LogOut();
                }}
                className="flex items-center gap-2 mt-4 text-red-600 font-semibold"
              >
                <FiLogOut />
                Đăng xuất
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

